import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBarsIndex = _resolveComponent("NavBarsIndex")!
  const _component_el_header = _resolveComponent("el-header")!

  return _withDirectives((_openBlock(), _createBlock(_component_el_header, {
    class: "layout-header",
    height: $setup.setHeaderHeight
  }, {
    default: _withCtx(() => [
      _createVNode(_component_NavBarsIndex)
    ]),
    _: 1
  }, 8, ["height"])), [
    [_vShow, !$setup.isTagsViewCurrenFull]
  ])
}